module.exports = __webpack_public_path__ + "static/the-alley-flash-6482ae5efeebd29417750ad815e10909.png";